// @flow
import React from 'react'
import FilterPill from 'src/components/_generic/filters/filter-pill'
import { useGetManyLocations } from 'src/api/locations/useGetManyLocations'

type Props = {
	filters: [],
	setFilters: () => any,
}

const RenderAdminLocationPills = ({ filters, setFilters }: Props) => {
	const { locations: adminLocations } = useGetManyLocations(
		filters?.adminLocations
	)

	const handleFilterRemove = (filter) => {
		let activeLocationFilters = filters?.adminLocations?.filter(
			(location) => '' + location !== '' + filter
		)
		setFilters({ ...filters, adminLocations: activeLocationFilters })
	}

	let locationPills = adminLocations?.filter((location) =>
		filters?.adminLocations?.includes(location?.id)
	)

	return (
		locationPills?.map((location) => {
			return (
				<FilterPill
					filter={location?.name}
					filterType={'LOCATION'}
					onRemove={() => handleFilterRemove(location?.id)}
					key={`location-badge-${location?.id}`}
				/>
			)
		}) ?? <></>
	)
}

export default RenderAdminLocationPills
